export { addScalarClassesToHeadless } from "./add-scalar-classes.js";
